import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { PrismIcon, PrismTooltip } from '@mylighthouse/prism-ember';
// @ts-expect-error: Incorrect type
import preventDefault from 'ember-event-helpers/helpers/prevent-default';
import { t } from 'ember-intl';

interface GeneralFilterBarFilterBarPillSignature {
  Args: {
    activeFilter: unknown;
    filter: unknown;
    isLoading?: boolean;
    segmentationFilterClicked: unknown;
  };
}

const GeneralFilterBarFilterBarPill = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <div class="active-filter-btn flex flex-row" data-test-id="active-filter">
    <div class="active-filter-left">
      <div class="active-filter-key text-200--regular truncate">
        {{#if @isLoading}}
          <div class="active-filter-key-loading"></div>
        {{else}}
          {{#if @activeFilter.translationKey}}
            {{t @activeFilter.translationKey count=1}}
          {{else}}
            {{@activeFilter.formattedValue}}
          {{/if}}
        {{/if}}
      </div>
      <div
        class="active-filter-value text-200--regular"
        data-test-id="active-filter-value"
      >
        {{#if @isLoading}}
          <div class="active-filter-value-loading"></div>
        {{else}}
          <p class="truncate">{{@filter.displayValue}}</p>
        {{/if}}
      </div>
    </div>
    <button
      class="button--unstyled ml-100"
      type="button"
      {{on
        "click"
        (preventDefault
          (fn @segmentationFilterClicked @activeFilter.key @filter.key)
        )
      }}
    >
      <PrismIcon @name="cross" @size="extra-small" />
    </button>
    {{#unless @isLoading}}
      <PrismTooltip @side="bottom" @text={{@filter.displayValue}} />
    {{/unless}}
  </div>
</template> satisfies TOC<GeneralFilterBarFilterBarPillSignature>;

export default GeneralFilterBarFilterBarPill;
